import { render, staticRenderFns } from "./AdvertisementForm.vue?vue&type=template&id=50914f39&scoped=true&"
import script from "./AdvertisementForm.vue?vue&type=script&lang=js&"
export * from "./AdvertisementForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "50914f39",
  null
  
)

export default component.exports